/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/handTyping"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Reynold Figueroa",
  title: "Hi all, I'm Reynold",
  subTitle: emoji(
    "A passionate Software Engineer 🚀 with 7+ years of experience crafting seamless, high-quality user experiences across web, mobile, and desktop platforms."
  ),
  resumeLink: true, // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = [
  // Supported links include: linkedin, github, email, gitlab, facebook, medium, stackoverflow, instagram, twitter and kaggle
  // Make Sure to include correct Font Awesome Classname to view your icon https://fontawesome.com/icons?d=gallery
  // To customize icons and social links, tweak src/components/SocialMedia
  {
    name: "linkedin",
    url: "linkedin.com/in/reynold-figueroa-36772a129",
    icon: "fab fa-linkedin-in",
    title: "LinkedIn"
  },
  {
    name: "email",
    url: "reynold0801@gmail.com",
    icon: "fas fa-envelope",
    title: "Gmail"
  },
  {
    name: "github",
    url: "https://github.com/rfig81",
    icon: "fab fa-github",
    title: "GitHub"
  }
];

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle:
    "Skilled Front-End Engineer with a Passion for High-Quality Development",
  softwareSkills: [
    // Make Sure to include correct Font Awesome Classname to view your icon https://fontawesome.com/icons?d=gallery
    {
      skillName: "HTML-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "SASS",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Vue.js",
      fontAwesomeClassname: "fab fa-vuejs"
    },
    {
      skillName: "React",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "SQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "fas fa-database"
    }
  ],
  skills: [
    {
      headline: emoji("🚀 Craft Exceptional Front-End Experiences"),
      subheading:
        "Design and develop high-quality, responsive user interfaces for web, mobile, and desktop platforms, prioritizing performance, accessibility, and user satisfaction."
    },
    {
      headline: emoji("⚡ Build Scalable Front-End Architectures"),
      subheading:
        "Utilize modern frameworks like React and Vue.js to create maintainable, modular, and testable codebases for large-scale applications."
    },
    {
      headline: emoji("🛠️ Full-Stack Collaboration"),
      subheading:
        "Integrate and optimize front-end components with back-end services, leveraging REST APIs, and databases like MongoDB and SQL."
    },
    {
      headline: emoji("📈 Improve User Engagement"),
      subheading:
        "Enhance user interaction and satisfaction by implementing data-driven design choices, UX principles, and innovative UI solutions."
    },
    {
      headline: emoji("🎯 Mentorship and Leadership"),
      subheading:
        "Lead teams, conduct code reviews, and mentor developers to maintain high standards and drive successful project outcomes."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Universidad Interamericana de Puerto Rico",
      logo: require("./assets/images/interLogo.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "2013 - 2018"
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Front-End Engineer",
      company: "Bancoli",
      companylogo: require("./assets/images/bancoliLogo.webp"),
      date: "2022 – 2024",
      descBullets: [
        "Led the team responsible for designing responsive home pages for 3+ products, increasing user engagement.",
        "Wrote modular, maintainable code, ensuring 100% test coverage and robust application performance.",
        "Conducted code reviews to uphold quality standards, detect bugs, and maintain design consistency across devices."
      ]
    },
    {
      role: "Mobile Engineer",
      company: "isiNET, LLC",
      companylogo: require("./assets/images/isinetLogo.webp"),
      date: "2019 – 2022",
      descBullets: [
        "Designed and developed customer-tailored mobile apps and contributed to web application projects.",
        "Collaborated directly with clients to ensure apps met specific needs, enhancing customer satisfaction.",
        "Provided user support, resolving technical issues and maintaining application reliability."
      ]
    },
    {
      role: "Software Engineer",
      company: "Freelancer",
      companylogo: require("./assets/images/freelanceLogo.webp"),
      date: "2017 – 2022",
      descBullets: [
        "Delivered a range of projects, including a cross-platform desktop POS system and an e-commerce platform.",
        "Led development team on selected projects, gaining leadership and entrepreneurial experience.",
        "Managed client interactions and project requirements to deliver on-time and tailored solutions."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Reach Out to me!"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: emoji("☎️ +49-15256614388")
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
